import React from 'react';
import FallbackWrappedElement from './FallbackWrappedElement/FallbackWrappedElement';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import PatientsToVisitPreview from 'Routes/Protected/PatientsToVisitPreview/PatientsToVisitPreview';
import SavePatientsForVisit from 'Routes/Protected/SavePatientsForVisit/SavePatientsForVisit';
import NobatPrefrences from 'Global/Components/CommonComponents/BottomBar/Components/SettingDrawer/components/DrawerContent/components/NobatPrefrences/NobatPrefrences';
import WebAppSettings from 'Global/Components/CommonComponents/BottomBar/Components/SettingDrawer/components/DrawerContent/components/WebAppSettings/WebAppSettings';
import UploadReceipt from 'Routes/Protected/UploadReceipt/UploadReceipt';

const PatientsForVisit = React.lazy(() =>
  import(
    'Routes/Protected/PatientsForVisit/PatientsForVisit'
  )
);
const UserFeedback = React.lazy(() =>
  import('Routes/Protected/UserFeedback/UserFeedback')
);
const PatientSurveyList = React.lazy(() =>
  import(
    'Routes/Protected/PatientSurveyList/PatientSurveyList'
  )
);
const InvoiceReceipt = React.lazy(() =>
  import('Routes/Protected/InvoiceReceipt/InvoiceReceipt')
);
const Pato = React.lazy(() =>
  import('Routes/Protected/Pato/Pato')
);
const AboutUs = React.lazy(() =>
  import('Routes/Protected/AboutUs/AboutUs')
);
const BankAccountList = React.lazy(() =>
  import('Routes/Protected/AccountList/BankAccountList')
);
const AddNewConfer = React.lazy(() =>
  import('Routes/Protected/AddNewConfer/AddNewConfer')
);
const AddNewMedicalForm = React.lazy(() =>
  import(
    'Routes/Protected/AddNewMedicalForm/AddNewMedicalForm'
  )
);
const ChangePasswrod = React.lazy(() =>
  import('Routes/Protected/ChangePasswrod/ChangePasswrod')
);
const CompleteProfileUser = React.lazy(() =>
  import(
    'Routes/Protected/CompleteProfileUser/CompleteProfileUser'
  )
);
const ContactUs = React.lazy(() =>
  import('Routes/Protected/ContactUs/ContactUs')
);
const CurrentPatients = React.lazy(() =>
  import('Routes/Protected/CurrentPatients/CurrentPatients')
);
const EditConfer = React.lazy(() =>
  import('Routes/Protected/EditConfer/EditConfer')
);
const EditMedicalForm = React.lazy(() =>
  import('Routes/Protected/EditMedicalForm/EditMedicalForm')
);

const ListServiceConfer = React.lazy(() =>
  import(
    'Routes/Protected/ListServiceConfer/ListServiceConfer'
  )
);
const MainPage = React.lazy(() =>
  import('Routes/Protected/MainPage/MainPage')
);
const ServiceReportSummary = React.lazy(() =>
  import(
    'Routes/Protected/ServiceReportSummary/ServiceReportSummary'
  )
);
const Messages = React.lazy(() =>
  import('Routes/Protected/Messages/Messages')
);
const PatientList = React.lazy(() =>
  import('Routes/Protected/PatientList/PatientList')
);
const ReferTo = React.lazy(() =>
  import('Routes/Protected/ReferTo/ReferTo')
);
const SearchPatientForReferal = React.lazy(() =>
  import(
    'Routes/Protected/SearchPatientForReferal/SearchPatientForReferal'
  )
);
const TestFlight = React.lazy(() =>
  import('Routes/Protected/TestFlight/TestFlight')
);
const UploadOnCallDocs = React.lazy(() =>
  import(
    'Routes/Protected/UploadOnCallDocs/UploadOnCallDocs'
  )
);
const LabTestResult = React.lazy(() =>
  import('Routes/Protected/LabTestResult/LabTestResult')
);
const FreezeContracts = React.lazy(() =>
  import('Routes/Protected/FreezeContracts/FreezeContracts')
);
const Quartering = React.lazy(() =>
  import('Routes/Protected/Quartering/Quartering')
);
const Lab = React.lazy(() =>
  import('Routes/Protected/Lab/Lab')
);

export const ControlledRoutes = (rootPaths) => [
  {
    path: '/main',
    component: (
      <FallbackWrappedElement>
        <MainPage />
      </FallbackWrappedElement>
    ),
    title: null,
  },

  {
    path: '/CurrentPatients',
    component: (
      <FallbackWrappedElement>
        <CurrentPatients />
      </FallbackWrappedElement>
    ),
    title: FindLangKey('current-patient-page-title'),
  },
  {
    path: '/PatientList',
    component: (
      <FallbackWrappedElement>
        <PatientList />
      </FallbackWrappedElement>
    ),
    title: FindLangKey('general-public-patients-list'),
  },
  {
    path: '/CompleteProfileUser',
    component: (
      <FallbackWrappedElement>
        <CompleteProfileUser />
      </FallbackWrappedElement>
    ),
    title: FindLangKey(
      'complete-user-information-navbar-title'
    ),
  },
  {
    path: '/SearchPatientForErja',
    component: (
      <FallbackWrappedElement>
        <SearchPatientForReferal />
      </FallbackWrappedElement>
    ),
    title: FindLangKey('new-referral-navbar-title'),
  },
  {
    path: '/about',
    component: (
      <FallbackWrappedElement>
        <AboutUs />
      </FallbackWrappedElement>
    ),
    title: FindLangKey('general-public-about-us'),
  },
  {
    path: '/UploadOnCallDocs',
    component: (
      <FallbackWrappedElement>
        <UploadOnCallDocs />
      </FallbackWrappedElement>
    ),
    title: FindLangKey(
      'upload-oncall-documents-navbar-title'
    ),
  },
  {
    path: '/ContactUs',
    component: (
      <FallbackWrappedElement>
        <ContactUs />
      </FallbackWrappedElement>
    ),
    title: FindLangKey('general-public-contact-us'),
  },
  {
    path: '/ListServiceConfer',
    component: (
      <FallbackWrappedElement>
        <ListServiceConfer />
      </FallbackWrappedElement>
    ),
    title: FindLangKey(
      'current-patients-patient-actions-list-service-confer'
    ),
    patient: true,
    isGeneral: false,
  },
  {
    path: '/BankAccountList',
    component: (
      <FallbackWrappedElement>
        <BankAccountList />
      </FallbackWrappedElement>
    ),
    title: FindLangKey('bank-account-list-navbar-title'),
  },
  {
    path: '/ChangePasswrod',
    component: (
      <FallbackWrappedElement>
        <ChangePasswrod />
      </FallbackWrappedElement>
    ),
    title: FindLangKey('general-public-change-password'),
  },
  {
    path: '/ServiceReportSummary',
    component: (
      <FallbackWrappedElement>
        <ServiceReportSummary />
      </FallbackWrappedElement>
    ),
    title: FindLangKey('general-public-performance-report'),
  },
  {
    path: '/testFlight',
    component: (
      <FallbackWrappedElement>
        <TestFlight />
      </FallbackWrappedElement>
    ),
    title: 'Test Flight',
  },
  {
    path: '/AddNewConfer',
    component: (
      <FallbackWrappedElement>
        <AddNewConfer />
      </FallbackWrappedElement>
    ),
    title: FindLangKey('add-new-confer-navbar-title'),
    patient: true,
    isGeneral: false,
  },
  {
    path: '/EditConferService',
    component: (
      <FallbackWrappedElement>
        <EditConfer />
      </FallbackWrappedElement>
    ),
    title: FindLangKey('edit-confer-service-navbar-title'),
    patient: true,
    isGeneral: false,
  },
  {
    path: '/AddNewElectronicForm',
    component: (
      <FallbackWrappedElement>
        <AddNewMedicalForm />
      </FallbackWrappedElement>
    ),
    title: FindLangKey('add-medical-font-navbar-title'),
    patient: true,
    isGeneral: false,
  },
  {
    path: '/messages',
    component: (
      <FallbackWrappedElement>
        <Messages />
      </FallbackWrappedElement>
    ),
    title: FindLangKey('messages-navbar-title'),
  },
  {
    path: '/ReferTo',
    component: (
      <FallbackWrappedElement>
        <ReferTo />
      </FallbackWrappedElement>
    ),
    title: FindLangKey('general-public-refer-to'),
  },
  {
    path: '/EditPatientForm',
    component: (
      <FallbackWrappedElement>
        <EditMedicalForm />
      </FallbackWrappedElement>
    ),
    title: FindLangKey(
      'electronic-forms-edit-form-title-navbar'
    ),
  },
  {
    path: '/LabTestResult',
    component: (
      <FallbackWrappedElement>
        <LabTestResult />
      </FallbackWrappedElement>
    ),
    title: FindLangKey('lab-test-result-navbar-title-lab'),
  },
  {
    path: '/FreezeContract',
    component: (
      <FallbackWrappedElement>
        <FreezeContracts />
      </FallbackWrappedElement>
    ),
    title: FindLangKey(
      'main-menu-drawer-link-freeze-contract'
    ),
  },
  {
    path: '/InvoiceReceipt',
    component: (
      <FallbackWrappedElement>
        <InvoiceReceipt />
      </FallbackWrappedElement>
    ),
    title: FindLangKey('main-menu-button-invoice-receipt'),
  },
  {
    path: '/Quartering',
    component: (
      <FallbackWrappedElement>
        <Quartering />
      </FallbackWrappedElement>
    ),
    title: FindLangKey('page-title-quartering'),
  },
  {
    path: '/Lab',
    component: (
      <FallbackWrappedElement>
        <Lab />
      </FallbackWrappedElement>
    ),
    title: FindLangKey('main-menu-button-lab-actions'),
  },
  {
    path: '/Pato',
    component: (
      <FallbackWrappedElement>
        <Pato />
      </FallbackWrappedElement>
    ),
    title: FindLangKey('patologoy-lab-route-title'),
  },
  {
    path: '/PatientPishNahad',
    component: (
      <FallbackWrappedElement>
        <UserFeedback />
      </FallbackWrappedElement>
    ),
    title: FindLangKey('user-pishnahad-route-title'),
  },
  {
    path: '/PatientSurveyList',
    component: (
      <FallbackWrappedElement>
        <PatientSurveyList />
      </FallbackWrappedElement>
    ),
    title: FindLangKey('user-survey-route-title'),
  },
  {
    path: '/PatientsForVisit',
    component: (
      <FallbackWrappedElement>
        <PatientsForVisit />
      </FallbackWrappedElement>
    ),
    title: FindLangKey('patients-for-visit-navbar-title'),
  },
  {
    path: '/PatientsForVisitPreview',
    component: (
      <FallbackWrappedElement>
        <PatientsToVisitPreview />
      </FallbackWrappedElement>
    ),
    title: FindLangKey(
      'current-patients-patient-actions-service-summary'
    ),
  },
  {
    path: '/SavePatientsForVisit',
    component: (
      <FallbackWrappedElement>
        <SavePatientsForVisit />
      </FallbackWrappedElement>
    ),
    title: FindLangKey(
      'save-patients-for-visit-navbar-title'
    ),
  },
  ...(rootPaths?.includes('/FreezeContract')
    ? [
        {
          path: '/UploadReceipt',
          component: (
            <FallbackWrappedElement>
              <UploadReceipt />
            </FallbackWrappedElement>
          ),
          title: FindLangKey(
            'freeze-contracts-btn-upload-bank-receipt'
          ),
          noAuth: true,
        },
      ]
    : []),
];
